import styled from 'styled-components'
import { Flex, Box } from 'vvs-uikit'

export const StyledTeamMoleProfileWrapper = styled(Box)`
  width: 100%;
  background: ${({ theme }) => theme.colors.darkNightBlue};
  padding: 16px 15px 32px 15px;
`

export const StyledTeamEditContainer = styled(Box)`
  width: 100%;
  background: ${({ theme }) => theme.colors.nightBlue};
`

export const MoleProgressBar = styled(Flex)<{ rankPercent: number }>`
  align-items: center;
  height: 32px;
  width: 100%;
  background: #60605f;
  background: linear-gradient(
    90deg,
    #00cbc0 ${({ rankPercent }) => 100 - rankPercent * 85}%,
    #60605f ${({ rankPercent }) => 100 - rankPercent * 82.5}%
  );
  border-radius: 4px;
  position: relative;

  :before {
    content: url('/images/vvsMinerMole/dotMan.svg');
    position: absolute;
    width: 32px;
    height: 32px;
    bottom: 0;
    left: ${({ rankPercent }) => 94.5 - rankPercent * 77}%;
    transform: translateX(-10px);
  }
`

export const GridWideCell = styled.div`
  grid-row: span 2;
`
export const StyledInput = styled.input<{ error?: boolean }>`
  font-size: 1.25rem;
  outline: none;
  border: 3px solid black;
  border-radius: 12px;
  flex: 1 1 auto;
  transition: color 300ms ${({ error }) => (error ? 'step-end' : 'step-start')};
  color: ${({ error, theme }) => (error ? theme.colors.failure : 'black')};
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  width: 100%;
  ::placeholder {
    color: ${({ theme }) => theme.colors.textDisabled};
  }
  padding: 10px 16px;
  -webkit-appearance: textfield;

  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  ::placeholder {
    color: ${({ theme }) => theme.colors.textDisabled};
  }
`
